import { useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const bottomNav = [
  { label: "首页", icon: "ri-home-5-line", path: "/" },
  { label: "品牌", icon: "ri-award-line", path: "/brand" },
  { label: "动态", icon: "ri-newspaper-line", path: "/news" },
  { label: "产品", icon: "ri-shopping-bag-3-line", path: "/products" },
  { label: "联系", icon: "ri-customer-service-2-line", path: "/contact" },
];

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 ${isHome ? "pt-0" : "pt-16 md:pt-20"}`}>
        <Outlet />
      </main>
      <SiteFooter />

      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200 pb-[env(safe-area-inset-bottom)]"
        aria-label="底部快捷导航"
      >
        <div className="flex items-center justify-around">
          {bottomNav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2.5 px-3 text-[11px] cursor-pointer transition-colors ${
                  isActive ? "text-primary-600" : "text-foreground-400"
                }`
              }
            >
              <i className={`${item.icon} text-xl`}></i>
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
      <div className="lg:hidden h-16"></div>
    </div>
  );
}